var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mx-2",attrs:{"depressed":"","disabled":!_vm.activationStore.isActivated,"color":"primary"},on:{"click":_vm.create}},[_vm._v(" "+_vm._s(_vm.$t('create'))+" "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v(" mdi-plus-thick ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }